/**
 * @module tasks (action-planning "actions")
 */
import { createReducer } from '@reduxjs/toolkit';
import { taskActions } from '~/behaviors/actions/task.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeTasks = (state, action) => {
  const tasks = action?.payload?.entities?.tasks ?? [];

  Object.values(tasks).forEach((task) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[task.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[task.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...task,
    };
  });
};

const removeTask = (state, action) => {
  const id = action?.payload?.id;

  if (id) {
    const { [id]: _deletedTask, ...remainingTasks } = state;

    return remainingTasks;
  }
};

const toggleTask = (state, action) => {
  const id = action?.payload;

  if (id) state[id].isComplete = !state[id].isComplete;
};

const tasks = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(accountActions.logout.pending, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
  builder.addCase(taskActions.fetchTaskList.fulfilled, mergeTasks);
  builder.addCase(taskActions.fetchTask.fulfilled, mergeTasks);
  builder.addCase(taskActions.createTask.fulfilled, mergeTasks);
  builder.addCase(taskActions.modifyTask.fulfilled, mergeTasks);
  builder.addCase(taskActions.removeTask.fulfilled, removeTask);
  builder.addCase(taskActions.toggleTask, toggleTask);
});

export default tasks;
